import { dateFromServer } from "@/functions/dates";
import axios, {AxiosHeaders, AxiosRequestConfig, AxiosResponse, AxiosResponseTransformer} from "axios";

export type Response<Data> = Promise<AxiosResponse<Data>>

export type DateString = string;
export type Version = string;

export type Lang = 'fr' | 'en' | 'es';

export interface MessageFromAPI {
  message: string;
  message_datetime: string;
  source: "agent" | "user" | "system"
}

export namespace PostMessage{
    export interface Params {
        message: string;
    }

    export type Result = MessageFromAPI
}

export namespace GetMessage{
    export type Result = MessageFromAPI[]
}

export interface HttpClient {
  post(url: string, body?: any, config?: AxiosRequestConfig): Promise<any>;

  get(url: string, config?: AxiosRequestConfig): Promise<any>;

  put(url: string, body?: any): Promise<any>;

  patch(url: string, body?: any): Promise<any>;

  delete(url: string, body?: any): Promise<any>;

  defaults: any;
}

export class SDK {
  constructor(private api: HttpClient) {
  }

  setPinHeader(pin: string){
    this.api.defaults.headers.common['X-Authz-Pin'] = pin
  }

  // AUTHENTICATION
  /* patchPersonPassword(params: PatchPersonPassword.Params): Response<PatchPersonPassword.Result> {
    return this.api.patch(`/person/password`, params);
  } */

  getMessages(): Response<GetMessage.Result> {
    return this.api.get(`/ai-bootcamp-discussion/messages`)
  }

  postMessage(params: PostMessage.Params): Response<PostMessage.Result> {
    return this.api.post(`/ai-bootcamp-discussion/message`, params)
    
    

    //const stream = response.data;

    /* stream.on('data', data => {
        console.log(data);
    });

    stream.on('end', () => {
        console.log("stream done");
    }); */
  }
}

export const sdk = new SDK(
  axios.create({
    withCredentials: true,
    baseURL: import.meta.env.VITE_API_URL,
    headers: new axios.AxiosHeaders({
      "Omind-Application": "ai.omind"
    })
  })
);

export default sdk